import {
    Component,
    Input,
    Output,
    EventEmitter
} from '@angular/core';

@Component({
    selector: 'app-select-list',
    templateUrl: './select-list.component.pug',
    styleUrls: ['./select-list.component.less']
})
export class SelectListComponent {
    @Input() value: string;
    @Input() options: string[];
    @Output() change: EventEmitter<string> = new EventEmitter();

    constructor(
    ) {
    }

    onChange(value) {
        this.change.emit(value);
    }
}
